var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"uploader",class:{ completed: _vm.isComplete }},[_c('div',{ref:"dropzoneElement",staticClass:"dropzone",attrs:{"id":"dropzone"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }